import React from 'react'

const Spinner = () => (
  <span className='loading-indicator'></span>
)

export default Spinner
